import { render } from "./CookiesView.vue?vue&type=template&id=30d7a8e7"
import script from "./CookiesView.vue?vue&type=script&lang=js"
export * from "./CookiesView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__